import React from 'react'
import Shimmer from './Shimmer'
import { FaImage } from "react-icons/fa"
import "./CarouselSkeleton.scss"
import { Container } from 'react-bootstrap'
function CarouselSkeleton() {
    return (
        <Container className="pushOver" fluid>
            <div className='CarouselSkeleton_Container'>
                <div className="CarouselSkeleton_wrapper">
                    <div className="CarouselSkeleton_Img"> <FaImage />
                        <div className="texting">
                            <div className="CarouselSkeleton_title"></div>
                            <div className="CarouselSkeletonLongText"></div>
                        </div>
                    </div>
                </div>

                <Shimmer />
            </div>
        </Container>
    )
}

export default CarouselSkeleton
